module.exports = __webpack_public_path__ + "img/SEVENELEVEN.ff5cdcc0.png";